module.exports = __webpack_public_path__ + "img/arch-low.c9e013eb.svg";